import { connect } from 'react-redux'
import VideoPlayerUI from '../components/simpleVideoPlayerUI'
import { VideoPlayerActions } from 'aria-viewer/players/videoplayer'

const mapStateToProps = ({ video, ...rest }, ownProps) => {
    return {
        isWalkingtour: false,
        ...ownProps,
    }
}

const mapDispatchToProps = (dispatch, getState) => {
    return {
        playVideo: () => dispatch(VideoPlayerActions.playVideo()),
        pauseVideo: () => dispatch(VideoPlayerActions.pauseVideo()),
    }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    playVideo: () => {
        // dispatchProps.playVideo()
        stateProps.player.play()
    },
    pauseVideo: () => {
        // dispatchProps.pauseVideo()
        stateProps.player.pause()
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(VideoPlayerUI)
